/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Drop_FrameInputs */

const en_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Drop Frame`)
};

const fr_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame du projet`)
};

const de_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt Drop Frame`)
};

const it_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto Drop Frame`)
};

const ru_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проектная рама`)
};

const es_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto Drop Frame`)
};

const zh_cn2_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目落帧`)
};

const ja_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトドロップフレーム`)
};

const hi_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट ड्रॉप फ्रेम`)
};

const pt_pt2_project_drop_frame = /** @type {(inputs: Project_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto Drop Frame`)
};

/**
* | output |
* | --- |
* | "Project Drop Frame" |
*
* @param {Project_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_drop_frame = /** @type {((inputs?: Project_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_drop_frame(inputs)
	if (locale === "de") return de_project_drop_frame(inputs)
	if (locale === "it") return it_project_drop_frame(inputs)
	if (locale === "ru") return ru_project_drop_frame(inputs)
	if (locale === "es") return es_project_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_project_drop_frame(inputs)
	if (locale === "ja") return ja_project_drop_frame(inputs)
	if (locale === "hi") return hi_project_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_project_drop_frame(inputs)
	return en_project_drop_frame(inputs)
});